"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkElement = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classNames_1 = require("../../../utils/classNames");
const theme_1 = require("../../../utils/theme");
const LinkElement = (props) => {
    const { children, className, href, target, palette = 'primary' } = props;
    const theme = (0, theme_1.useTheme)();
    const paletteClasses = [
        ...theme.palette[palette || 'none'].text,
        ...theme.palette[palette || 'none'].hover,
    ];
    const baseClassName = (0, classNames_1.cn)(paletteClasses, className, 'hover:bg-transparent');
    return ((0, jsx_runtime_1.jsx)("a", { href: href || '#', target: target || '_self', className: baseClassName, children: children }));
};
exports.LinkElement = LinkElement;
